import { useTranslation } from "react-i18next"
import CountsList from "components/commons/CountsList"
import ModuleActivityChart from "features/core/company/components/ModuleActivityChart"
import { useGetWhistlesStatsQuery } from "../api/whistleApiSlice"


const WhistlesStats = () => {

    const [t] = useTranslation(["global", "whistle"])

    const {
        data: statsResponse,
        isFetching: statsIsFetching,
        isSuccess: statsIsSuccess,
        isError: statsIsError,
        erorr: statsError,
        refetch: statsRefetch
    } = useGetWhistlesStatsQuery()

    const statusLabelByStatus = (status) => {
        switch (status) {
            case "OPEN": return t("whistle:entity.warning.status_more.open")
            case "IN_CHARGE": return t("whistle:entity.warning.status_more.in_charge")
            case "SOLVED": return t("whistle:entity.warning.status_more.solved")
            case "CLOSED": return t("whistle:entity.warning.status_more.closed")
            default: return
        }
    }

    return (
        <div className={`card bg-black bg-opacity-10 mb-4`}>
            <div className="card-header">
                <i className="fa-solid fa-chart-pie"></i> {t("whistle:menu.stats")}
            </div>

            {
                statsIsSuccess &&
                <>
                    <div className="card-body text-center">
                        <div className="row text-start">
                            <div className="col-md-3">
                                <CountsList data={
                                    [
                                        {
                                            key: statusLabelByStatus("OPEN").toUpperCase(),
                                            value: statsResponse.byStatus.OPEN,
                                            foregroundClass: "text-dark",
                                            backgroundClass: "bg-light"
                                        },
                                        {
                                            key: statusLabelByStatus("IN_CHARGE").toUpperCase(),
                                            value: statsResponse.byStatus.IN_CHARGE,
                                            foregroundClass: "text-dark",
                                            backgroundClass: "bg-warning"
                                        },
                                        {
                                            key: statusLabelByStatus("SOLVED").toUpperCase(),
                                            value: statsResponse.byStatus.SOLVED,
                                            foregroundClass: "text-white",
                                            backgroundClass: "bg-success"
                                        },
                                        {
                                            key: statusLabelByStatus("CLOSED").toUpperCase(),
                                            value: statsResponse.byStatus.CLOSED,
                                            foregroundClass: "text-white",
                                            backgroundClass: "bg-black bg-opacity-10"
                                        }
                                    ]
                                } />
                            </div>
                            <div className="col-md-6">
                                <ModuleActivityChart data={[
                                    { name: statusLabelByStatus("OPEN"), value: statsResponse.byStatus.OPEN, color: "white" },
                                    { name: statusLabelByStatus("IN_CHARGE"), value: statsResponse.byStatus.IN_CHARGE, color: "#ffc107" },
                                    { name: statusLabelByStatus("SOLVED"), value: statsResponse.byStatus.SOLVED, color: "#198754" },
                                    { name: statusLabelByStatus("CLOSED"), value: statsResponse.byStatus.CLOSED, color: "gray" },
                                ]} />
                            </div>
                            <div className="col-md-3">
                                <h1><i className="fa-solid fa-masks-theater"></i></h1>
                                <h4>{t("whistle:property.anonymity")}</h4>
                                <h3>{Math.round(((statsResponse.byAnonymity.true || 0) / ((statsResponse.byAnonymity.true || 0) + (statsResponse.byAnonymity.false || 0)) || 0) * 100)} %</h3>
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}

export default WhistlesStats